class SendYourDataOpenSourceModel {
    title;
    githubRepo;
}
export class SendYourDataContentModel {
    id;
    collectionId;
    title;
    dataSource;
    openSource;
    logo; // svg or png
    filepath; // markdown file
    tags;
    markdown;
    shortDescription;
}
//# sourceMappingURL=send-your-data-content.js.map